import { render, staticRenderFns } from "./WorkSpace.vue?vue&type=template&id=16342306&"
import script from "./WorkSpace.vue?vue&type=script&lang=js&"
export * from "./WorkSpace.vue?vue&type=script&lang=js&"
import style0 from "./WorkSpace.vue?vue&type=style&index=0&id=16342306&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports